import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Layout from '@/components/layout'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css' // Progress 进度条样式  
import qualityPrint from '../components/sales/business/bill/qualityPrint.vue'
import qualityPrintbatch from '../components/sales/business/bill/qualityPrintbatch.vue'
import qualityReceipt from '../components/sales/business/bill/qualityReceipt.vue'
import qualityPrintbatchQuery from '../components/sales/business/bill/qualityPrintbatchQuery.vue'
import qualityReceiptQuery from '../components/sales/business/bill/qualityReceiptQuery.vue'
import qualityPrintbatchQueryReturn from '../components/sales/business/return/qualityPrintbatchQueryReturn.vue'
import qualityPrintbatchReturn from '../components/sales/business/return/qualityPrintbatchReturn.vue'

import wujiQualityPrintbatch from '../components/sales/business/bill/wujiQualityPrintbatch.vue'
// const _import = require('./_import_' + process.env.NODE_ENV);
const _import = require('./_import_production');
// 

Vue.use(VueRouter)

const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const routes = [

  {
    path: '/',
    redirect: '/index'
  },
  {
    name: 'qualityPrint',
    path: '/qualityPrint',
    component: qualityPrint,
    meta: {
      noAuth: true
    }
  },
  {
    name: 'qualityPrintbatch',
    path: '/qualityPrintbatch',
    component: qualityPrintbatch,
    meta: {
      noAuth: true
    }
  },
  {
    name: 'qualityReceipt',
    path: '/qualityReceipt',
    component: qualityReceipt,
    meta: {
      noAuth: true
    }
  },
  {
    name: 'qualityPrintbatchQuery',
    path: '/qualityPrintbatchQuery',
    component: qualityPrintbatchQuery,
    meta: {
      noAuth: true
    }
  },
  {
    name: 'qualityReceiptQuery',
    path: '/qualityReceiptQuery',
    component: qualityReceiptQuery,
    meta: {
      noAuth: true
    }
  },
  {
    name: 'qualityPrintbatchQueryReturn',
    path: '/qualityPrintbatchQueryReturn',
    component: qualityPrintbatchQueryReturn,
    meta: {
      noAuth: true
    }
  },
  {
    name: 'qualityPrintbatchReturn',
    path: '/qualityPrintbatchReturn',
    component: qualityPrintbatchReturn,
    meta: {
      noAuth: true
    }
  },
  {
    name: 'wujiQualityPrintbatch',
    path: '/wujiQualityPrintbatch',
    component: wujiQualityPrintbatch,
    meta: {
      noAuth: true
    }
  },
  // {
  //   path: '/test', component: _import("/test"), meta: {
  //     noAuth: true
  //   }
  // },
  {
    path: '/password',
    name: 'password',
    component: Layout,
    children: [{
      path: "",
      component: _import("/password"),
      meta: {
        title: '修改密码',
        fullPath: '/password',
        isHide: true
      }
    }]
  },
  {
    path: '/login',
    name: 'login',
    component: _import('/login'),
    meta: {
      noAuth: true
    }
  },
  {
    path: "/bigScreen",
    component: _import("/bigScreen"),
    meta: {
      noAuth: true,
      title: '51生意宝'
    }
  },
  {
    path: '/customprint/:type',
    name: 'customprint',
    component: _import('/customprint'),
    meta: {
      title: "设置 打印模板",
    }
  },
  {
    path: '/customprintview/:type/:value',
    name: 'customprintview',
    component: _import('/customprintview'),
    meta: {
      title: "打印",
    }
  },
  // {
  //   path: '/qywxAuth/:path?',
  //   name: 'qywxAuth',
  //   component: _import('/qywxAuth'),
  //   props: true,
  //   meta: {
  //     title: '微信企业认证',
  //     noAuth: true
  //   }
  // }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.meta && to.meta.noAuth) {
    next()
  } else {
    /* 判断是否有已登录 */
    if (localStorage.getItem("token") ? true : false) {
      /* 判断是否已读取身份信息 */
      if (store.getters.hasIdentityInfo) {
        next()
      } else {
        var mode = localStorage.getItem("mode");
        // 
        if (mode != null) {

          store.dispatch("changeSetting", {
            key: "tagsView",
            value: mode == 'true',
          });
        }
        /* 获取身份信息 */
        store.dispatch("getIdentityInfo").then(res => {
          let permissionMenus = res.Menus;
          let permissionRouters = [];

          /*先取出顶级菜单，Pid为0的就是顶级菜单*/
          permissionMenus.forEach((m, i) => {
            if (m.Pid == 0) {
              let parentMenu = {
                path: m.FullPath,
                name: m.Url,
                component: Layout,
                meta: {
                  id: m.MenuId,
                  title: m.MenuName,
                  fullPath: m.FullPath,
                  icon: m.Icon ? window.location.origin + '/api' + m.Icon : 'component'
                }
              }
              permissionRouters.push(parentMenu)
            }
          })

          function convertTree(routers) {
            routers.forEach(r => {
              permissionMenus.forEach((m, i) => {
                if (m.Pid != 0 && m.Pid == r.meta.id) {
                  if (!r.children) r.children = []
                  let menu = {
                    path: m.Url,
                    name: m.Url,
                    component: _import(m.FullPath + "/"),
                    meta: {
                      id: m.MenuId,
                      title: m.MenuName,
                      fullPath: m.FullPath,
                      // canRead: m.canRead,
                      // canWrite: m.canWrite,
                      // canReview: m.canReview
                    }
                  }
                  r.children.push(menu)
                }
              })
              if (r.children) {
                convertTree(r.children)
              }
            })
          }
          convertTree(permissionRouters)

          permissionRouters.unshift({
            path: '/index',
            name: 'index',
            component: Layout,
            meta: {
              title: '工作台',
              fullPath: '/index',
              isDashboard: true,
              affix: true,
              icon: 'dashboard'
            },
            children: [{
              path: "",
              component: _import("/index"),
              meta: {
                title: '工作台',
                fullPath: '/index',
                isHide: true
              }
            }]
          })

          store.commit('SET_PERMISSION_ROUTERS', permissionRouters);
          router.addRoutes(permissionRouters);
          router.addRoutes([{
            path: '*',
            redirect: '/index'
          }]);
          // 
          next({
            path: to.path,
            replace: true
          });
        })
      }
    } else {
      next('/login')
      if (from.path == "/login") {
        NProgress.done()
      }
    }
  }
  // next({ path: to.path, replace: true });
})

router.afterEach((to, from) => {
  NProgress.done()
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + ' | ' + store.state.sys.title
  } else {
    document.title = store.state.sys.title
  }
})

export default router